import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ResolutionService } from '../resolution.service';
import { Resolution } from '../resolution';
import { Popover } from 'primeng/popover';
import { toggleEllipsisPopover, getEllipsisOptionValue } from 'src/app/modules/crm/shared/utilities/ellipsis-popover.util';
import { buttonStatus } from '../../../shared/constants/button-class';
import { ellipsisOptions } from '../../../shared/constants/ellipsis-options';
import { FormGroup } from '@angular/forms';
import { FormField } from '../../../shared/form-field/form-field';
import { ContractFormFieldService } from '../../../services/contract-form-field.service';

@Component({
  standalone: false,
  selector: 'symptom-two',
  templateUrl: 'symptom-two.template.html',
  styleUrls: ['symptom-two.scss'],
  providers: [ResolutionService, ContractFormFieldService],
})
export class SymptomTwoComponent implements OnInit {
  searchResults: Resolution[];
  cols: any[];
  selectedItem: any;
  btnStatus: any = buttonStatus;
  options: any[] = ellipsisOptions;
  selectedEllipsisItem: any;
  formModalInfo: FormField<any>[] = [];

  displayAdd: boolean;
  displayUpdate: boolean;

  constructor(
    private search: ResolutionService,
    private cdr: ChangeDetectorRef,
    private contractService: ContractFormFieldService,
  ) {
    this.displayAdd = false;
    this.displayUpdate = false;
  }

  ngOnInit() {
    this.searchResults = this.search.getSymptomTwos();
    this.cols = [{ field: 'symptom', header: '' }];
    this.options = [
      { label: 'Add', value: 'add' },
      { label: 'Update', value: 'update' },
    ];
    this.contractService
      .getFormModalFields()
      .subscribe((formModalInfo) => (this.formModalInfo = formModalInfo));
  }
  selectItem(event, item, Popover: Popover) {
    this.selectedItem = item;
    toggleEllipsisPopover(event, Popover);
  }
  handleOpen(e) {
    if (getEllipsisOptionValue(e) === 'add') {
      this.displayAdd = true;
    } else {
      this.displayUpdate = true;
    }
    this.cdr.detectChanges();
  }
  onYes() {
    this.displayAdd = false;
    this.displayUpdate = false;
    this.cdr.detectChanges();
  }
}
